<template>
    <div>
        <vs-popup class="holamundo" title="Add New Program" :active.sync="popupActive">
            <vx-input-group class="mb-3">
                <ul class="con-s">
                    <li>
                        <label for="">Featured Program</label>
                        <vs-switch v-model="program.featured" vs-icon-off="moon" vs-icon-on="moon" />
                    </li>
                    <!-- <li>
                        <label for="">Editor Choice</label>
                        <vs-switch v-model="program.editor_choice" vs-icon-off="moon" vs-icon-on="moon" />
                    </li> -->
                    <li>
                        <label for="">Football Match</label>
                        <vs-switch v-model="program.type" vs-icon-off="moon" vs-icon-on="moon" />
                    </li>
                    <li>
                        <label for="">For Kids</label>
                        <vs-switch v-model="program.kids" vs-icon-off="moon" vs-icon-on="moon" />
                    </li>
                </ul>
            </vx-input-group>
            <vx-input-group class="mb-3" v-if="channels.length !=0">
                <v-select
          id="country"
          v-model="program.channel_id"
          :options="channels"
         
          label="name"
        />
            </vx-input-group>
            <vx-input-group class="mb-3">
                <vs-input v-model="program.title" placeholder="Title" />
            </vx-input-group>
            <vx-input-group class="mb-3">
                <vs-input v-model="program.decription" placeholder="Description" />
            </vx-input-group>
            <vx-input-group class="mb-3">
                <vs-input v-model="program.presenter" placeholder="Presenter" />
            </vx-input-group>
            <vx-input-group class="mb-3">
                <date-picker v-model="program.start_time" type="datetime"  ></date-picker> =>
                <date-picker v-model="program.end_time" type="datetime" ></date-picker>
            </vx-input-group>
      
            <vx-input-group class="mb-3">
                Logo:
                <input type="file" class="form-control-file" ref="logo" v-on:change="handleLogo()">
            </vx-input-group>
            <vx-input-group class="mb-3">
                Image:
                <input type="file" class="form-control-file" ref="image" v-on:change="handleImage()">
            </vx-input-group>
            <vx-input-group class="mb-3">
                <vs-button color="warning" type="filled" @click="storeProgram">Save</vs-button>
            </vx-input-group>
        </vs-popup>
        <vs-button  @click="popupActive = true;clearData()" >Add Program</vs-button>
        <table class="table table-hover " style="background:#fff">
            <thead  >
                <th>#</th>
                <th>Channel</th>
                <th>title</th>
                <th>presenter</th>
                <th>date</th>
                <th>Action</th>
            </thead>
            <tbody>
                <tr v-for="(program,index) in schedule.data" :key="index">
                      <td>{{index}}</td>
                      <td><span v-if="program.channel">{{program.channel.name}}</span></td>
                      <td>{{program.title}}</td>
                      <td>{{program.presenter}}</td>
                      <td>{{program.start_date}}</td>
                      <td class="flex">
                        <vs-button radius color="danger" type="filled" icon="delete" size="small" @click="deleteProgram(program)"></vs-button>
                       <vs-button class="mx-1" radius color="warning" type="filled" icon="edit" size="small" @click="editProgram(program)"></vs-button>
                      </td>
                </tr>
            </tbody>
        </table>
        
     
    </div>
    
</template>
<script>
import { deprecationHandler } from 'moment';
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    components:{vSelect,DatePicker },
    data() {
        return {
            popupActive: false,
            schedule:[],
            channels:[],
            program:{
                id:0,
                title:'',
                decription:'',
                presenter:'',
                image:'',
                logo:'',
                type:1,
                kids:0,
                featured:0,
                live:0,
                channel_id:0,
                sequence:0,
                start_time:'',
                end_time:'',
            }
        }
    },
    created() {
        this.getChannels();
        this.getSchedule();
    },
    methods: {

        getChannels(){
           this.axios.get(`${this.$apiUrl}/v2/tv/channels/all`).then(res=>{
            this.channels=res.data
           })
        },

        getSchedule(){
           this.axios.get(`${this.$apiUrl}/v2/tv/schedule`).then(res=>{
               this.schedule=res.data;
           })
        },

        storeProgram(){
            const data=new FormData();
            data.append('id',this.program.id)
            data.append('title',this.program.title)
            data.append('decription',this.program.decription)
            data.append('presenter',this.program.presenter)
            data.append('image',this.program.image)
            data.append('logo',this.program.logo)
            data.append('kids',this.program.kids? 1 : 0)
            data.append('type',this.program.type? 1 : 0)
            data.append('featured',this.program.featured? 1 : 0)
            data.append('live',this.program.live? 1 : 0)
            data.append('channel_id',this.program.channel_id.id)
            data.append('sequence',this.program.sequence)
            data.append('start_time',this.program.start_time)
            data.append('end_time',this.program.end_time)
            this.axios.post(`${this.$apiUrl}/v2/tv/schedule`,data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res=>{
                res;
              //  this.clearData();
                this.getSchedule()
            })
        },

        deleteProgram(prog){
            this.axios.post(`${this.$apiUrl}/v2/tv/schedule/${prog.id}/del`).then(res=>{
                this.getSchedule()
            })
        },
        
        editProgram(prog){
            this.program=prog;
            this.popupActive=true;
        },
        
        clearData(){
            this.program={id:0,title:'',decription:'',presenter:'',image:'',logo:'',type:0,kids:0,featured:0,live:0,channel_id:0,sequence:0,start_time:'',end_time:'',}
        },

        handleImage() {
                this.program.image = this.$refs.image.files[0];
            },
            handleLogo() {
                this.program.logo = this.$refs.logo.files[0];
            },
        
    },
}
</script>
<style lang="scss">
    .mx-datepicker-popup {
        z-index: 1000000 !important;
    }
</style>
 